import React from "react";

// Ciclo de color oficial LoremiG — el índice solo avanza en caracteres
// visibles (los espacios se preservan sin consumir color).
const CYCLE = ["fucsia", "turquesa", "naranja", "amarillo", "lima", "morado"];

export default function RainbowText({ text, as: Tag = "span", className }) {
  let i = 0;
  return (
    <Tag className={className}>
      {[...text].map((ch, k) =>
        ch === " " ? (
          " "
        ) : (
          <span key={k} className={`c-${CYCLE[i++ % CYCLE.length]}`}>
            {ch}
          </span>
        )
      )}
    </Tag>
  );
}
